module.exports = __webpack_public_path__ + "static/media/document-slash.70771eb0.svg";